import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// Kiosk Pages — each is full-screen, no shared layout
import { KioskHome } from './pages/kiosk/KioskHome';
import { PaymentSelect } from './pages/kiosk/PaymentSelect';
import { OtpVerify } from './pages/kiosk/OtpVerify';
import { PaymentProcessing } from './pages/kiosk/PaymentProcessing';
import { PaymentSuccess } from './pages/kiosk/PaymentSuccess';
import { PaymentFailed } from './pages/kiosk/PaymentFailed';
// Admin Pages
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminLayout } from './components/layouts/AdminLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { TicketPrices } from './pages/admin/TicketPrices';
import { TicketSales } from './pages/admin/TicketSales';
import { Transactions } from './pages/admin/Transactions';
import { Reports } from './pages/admin/Reports';
import { Users } from './pages/admin/Users';
import { Settings } from './pages/admin/Settings';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Kiosk Routes — each page is full-screen */}
        <Route path="/" element={<KioskHome data-id="element-3" />} data-id="element-2" />
        <Route path="/payment" element={<PaymentSelect data-id="element-5" />} data-id="element-4" />
        <Route path="/otp" element={<OtpVerify data-id="element-7" />} data-id="element-6" />
        <Route path="/processing" element={<PaymentProcessing data-id="element-9" />} data-id="element-8" />
        <Route path="/success" element={<PaymentSuccess data-id="element-11" />} data-id="element-10" />
        <Route path="/failed" element={<PaymentFailed data-id="element-13" />} data-id="element-12" />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin data-id="element-15" />} data-id="element-14" />
        <Route path="/admin" element={<AdminLayout data-id="element-17" />} data-id="element-16">
          <Route index element={<AdminDashboard data-id="element-19" />} data-id="element-18" />
          <Route path="prices" element={<TicketPrices data-id="element-21" />} data-id="element-20" />
          <Route path="sales" element={<TicketSales data-id="element-23" />} data-id="element-22" />
          <Route path="transactions" element={<Transactions data-id="element-25" />} data-id="element-24" />
          <Route path="reports" element={<Reports data-id="element-27" />} data-id="element-26" />
          <Route path="users" element={<Users data-id="element-29" />} data-id="element-28" />
          <Route path="settings" element={<Settings data-id="element-31" />} data-id="element-30" />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-33" />} data-id="element-32" />
      </Routes>
    </BrowserRouter>;
}